module.exports = __webpack_public_path__ + "static/media/hero-bg-img.8b14f384.png";